import React from 'react';
import { Tooltip, Typography, useTheme } from '@mui/material';
import { getStyled } from './styles';

const ToolTip = ({ title, content, children }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  return (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        popper: classes.tooltipPopper,
      }}
      title={
        <React.Fragment>
          <Typography gutterBottom color='inherit'>
            {title}
          </Typography>
          {content && <Typography>{content}</Typography>}
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};

export default ToolTip;
